import './PageContainer.scoped.scss'
import './OverviewStats.scoped.scss'

const statusMap = {
    'live': 'Live',
    'draft': 'Draft',
    'closed': 'Closed',
}

export default function OverviewStats() {
  const { stats, status } = useSel((s) => s.dashboard)

  const dashboardStats = [
    { label: 'Dashboard audience', value: stats?.audienceCount || 0 },
    { label: 'Completed primary goal', value: stats?.primaryGoalsCompleted },
    // { label: 'Interacted users', value: stats?.usersInteracted || 0 },
    { label: 'Close date', value: stats?.closeDate || 'Not set' },
  ]

  const completePercentage = stats?.audienceCount ? ((stats?.primaryGoalsCompleted || 0) / stats?.audienceCount) * 100 : 0


  return (
    <div className='box gap' id='status'>
        <div className='progress-container'>
            <div className='progress-column'>
                <div className='progress-column-filler' style={{height: `${completePercentage}%`}}></div>
            </div>
            <p>{`${stats?.primaryGoalsCompleted || 0}/${stats?.audienceCount || 0}`} complete</p>
        </div>
        <div className='main'>
            <div className='header row'>
                <h1 className='no-margin-top'>Dashboard { statusMap[status] || '' }</h1>
            </div>
            <div className='primary-actions'>
                {dashboardStats.map(stat => {
                const val = stat.value
                if (val === null || val === undefined) {
                    return null
                }
                return (
                    <div key={stat.label} className="primary-action">
                        <p className='number'>{stat.value}</p>
                        <p className='label'>{stat.label}</p>
                    </div>
                )
            })}
            </div>
        </div>
    </div>
  )
}
